'use server';

import { z } from 'zod';

const emailSchema = z.string().email('Please enter a valid email address');

type NewsletterResult =
  | { ok: true; data: { email: string } }
  | { ok: false; error: string };

/**
 * Newsletter subscription stub — Phase D will wire in the real provider.
 * Currently validates the address and logs to console for diagnostics.
 */
export async function subscribeNewsletter(email: unknown): Promise<NewsletterResult> {
  const parsed = emailSchema.safeParse(email);
  if (!parsed.success) {
    return { ok: false, error: 'Please enter a valid email address.' };
  }

  // Phase D: replace this with the real integration (e.g. Loops, ConvertKit, Resend audiences).
  console.log('[newsletter] subscription stub:', parsed.data);

  return { ok: true, data: { email: parsed.data } };
}
